import React from 'react';

import { SVGComponentProps } from './svg.types';

const AutomationSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M7.98002 1.33337C4.30002 1.33337 1.31335 4.32004 1.31335 8.00004C1.31335 11.68 4.30002 14.6667 7.98002 14.6667C11.66 14.6667 14.6467 11.68 14.6467 8.00004C14.6467 4.32004 11.6667 1.33337 7.98002 1.33337ZM10.48 8.23337L8.00002 11.0534L7.70669 11.3867C7.30002 11.8467 6.96669 11.7267 6.96669 11.1067V8.46671H5.83335C5.32002 8.46671 5.18002 8.15337 5.52002 7.76671L8.00002 4.94671L8.29335 4.61337C8.70002 4.15337 9.03335 4.27337 9.03335 4.89337V7.53337H10.1667C10.68 7.53337 10.82 7.84671 10.48 8.23337Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AutomationSVG;
